module.exports = __webpack_public_path__ + "static/media/logo-playson.1e9bef4a.svg";